import React, { useCallback, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { t } from '@sportninja/common/i18n'
import req from '@sportninja/common/api/request'
import queryString from 'query-string'
import { withRouter } from 'react-router-dom'
import utils from '@sportninja/common/components/ReactTableStatistics/utils'

import helpers from '../../components/StatisticsTable/helpers'
import TabbedStatisticsContainer from '../../components/StatisticsTable/TabbedStatisticsContainer'
import { FilterButtons } from '../../components/SearchMenu/SearchFilterButtons'

const PlayerStatistics = ({ history, id, homeTeamId, visitingTeamId }) => {
  const teamTabs = useMemo(
    () => ({
      home: {
        key: 'home',
        button: { short: t('common:home'), long: t('common:home') },
        teamId: homeTeamId,
      },
      visiting: {
        key: 'visiting',
        button: { short: t('common:visiting'), long: t('common:visiting') },
        teamId: visitingTeamId,
      },
    }),
    [homeTeamId, visitingTeamId]
  )

  const parsedSearch = queryString.parse(history.location.search)
  const existingTeamTab = parsedSearch.team
  const [statColumnType, setStatColumnType] = useState('gamePlayer')
  const [selectedTeamTab, setSelectedTeamTab] = useState(
    existingTeamTab || 'home'
  )

  const columns = [
    helpers.getNameColumn('player', utils.playerSort),
    ...utils.getStatColumns(statColumnType),
  ]

  const fetchData = useCallback(
    async (selectedTab) => {
      const teamId =
        selectedTeamTab === 'home'
          ? teamTabs.home.teamId
          : teamTabs.visiting.teamId
      return await req(`/games/${id}/stats/players/team/${teamId}`, {
        query: { goalie: selectedTab.key === 'goalie' ? 1 : 0 },
      })
    },
    [selectedTeamTab, teamTabs]
  )

  return (
    <TabbedStatisticsContainer
      key={selectedTeamTab}
      columns={columns}
      defaultSort={
        statColumnType === 'gameGoalie' ? 'save percentage' : 'points'
      }
      defaultOrder='desc'
      fetchData={fetchData}
      onClick={(tabName) => {
        setStatColumnType(
          tabName.key === 'goalie' ? 'gameGoalie' : 'gamePlayer'
        )
      }}
    >
      <FilterButtons
        onClick={(type) => {
          setSelectedTeamTab(type)
          history.replace({ ...history.location, search: `team=${type}` })
        }}
        selectedType={selectedTeamTab}
        types={teamTabs}
      />
    </TabbedStatisticsContainer>
  )
}

PlayerStatistics.propTypes = {
  history: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  homeTeamId: PropTypes.string.isRequired,
  visitingTeamId: PropTypes.string.isRequired,
}

export default withRouter(PlayerStatistics)
